import { react2angular } from 'react2angular';
import app from '../../../browser/addform/scripts/app';
import { AuthWidgetContainer } from './AuthWidget.container';

app.component('authWidget', react2angular(AuthWidgetContainer, [], ['config', 'httpApi', 'logger', 'authService']));
